import { useState } from "react";
import Modal from "../../../myfin_v2/elements/Modal";
import buttoncss from "../../../myfin_v2/css/button.module.css";
import InputGroup from "../../../myfin_v2/elements/InputGroup";
import { Button } from "../../../myfin_v2/elements/Button";
import commoncss from "../../../myfin_v2/css/common.module.css"
import { ReactComponent as CloseIcon } from "../../../myfin_v2/assets/icons/close.svg";

const DifferenceRemarksModal = ({ handleClose, data, type }) => {

    const [remarks, setRemarks] = useState(data?.remarks || "");

    return(
        <>
            <Modal
                width="500px"
                title="Remarks"
                bodycss={commoncss.unsetPadding}
                headerActions={
                    <CloseIcon
                        className="clickable"
                        onClick={handleClose}
                    />
                }
                footerActions={
                    <>
                        <Button
                            btnColor={buttoncss.secondary}
                            label="Cancel"
                            onClick={handleClose}
                        />
                        <Button
                            btnColor={buttoncss.primary}
                            label="Save"
                        />
                    </>
                }
            >

                <div className={commoncss.pd1530}>
                    <InputGroup
                        label="Remarks"
                        inputs={[
                        <>
                            <textarea
                                rows={4}
                                placeholder="Enter remarks"
                                value={remarks}
                                onChange={(e) => setRemarks(e.target.value)}
                            />
                        </>,
                        ]}
                    />
                </div>
                
            </Modal>
        </>
    )

}

export default DifferenceRemarksModal;